import React, { useEffect, useRef, useState, useReducer } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { ITopBarComponentsProps } from "./ITopBarComponentsProps";
import { authorizeActions, globalActions } from "../../store/actions";
import "./TopBarComponent.scss";
import "./topbar-responsive.scss";
import { Map } from "immutable";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft, faChevronDown, faCog } from "@fortawesome/free-solid-svg-icons";
import { GroupService } from "../../api/services/groups";
import miscUtils from "../../utils/miscUtils";
import { push } from "connected-react-router";
import { SearchIcon } from "../../constants/icons";
import useComponentVisible from "../../utils/visible/visible";
import { Link } from "react-router-dom";
import TopBarMenuComponent from "./topBarMenu";
import TopBarNotificationComponent from "./topBarNotification";
import { ReactComponent as GroupApp } from "./white.svg";
import appConfig from "appConfig";
import AppModal from "elements/modal/appModal";
import LectureMenuIcon from './icons/MenuIcon';
import useWindowSize from "utils/windowSize";
import { useHistory } from 'react-router';
import { SSOMethod } from "containers/IntegrationsContainer/SingleSignOn/domain";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TobBarMessages from "./TopBarMessages";
import { useAtom } from "jotai";
import { chatsLoadingAtom, groupMenuMessagesShowAtom, showBannerAtom, showchannelSidebarAtomOnMobile, showCommunitySwitcherAtom, showUpgradeBannerAtom, universalSearchResultsAtom } from 'showMessageMenuAtom';
import Echo from "laravel-echo";
import ConfirmModal from "containers/messaging/ConfirmModal";
import {  DirectChatsContext } from "containers/main/MainComponent";
import { setlocalStorageValue } from "utils/localStorage";

const TopBarComponent: React.FC<ITopBarComponentsProps> = (props: any) => {
  const {
    toggleHamburgerMenu,
    goTo,
    authed,
    global,
    theme,
    group,
    showPublicGroupSignup,
    isModalActive,
    setChannelSidebarStatus,
    subdomain,
  } = props;

  const windowSize = useWindowSize();
  const [showBanner,] = useAtom(showBannerAtom);
  const [showUpgradeBanner,] = useAtom(showUpgradeBannerAtom);
  // const [, setIsRightSideBarOpen] = useAtom(gettingStartedRightSideBarAtom);

  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const whiteCommunityTheme = props.theme && props.theme.custom && props.theme.custom.primaryColor === '#ffffff'

  const [results, setResults] = useState<any>([]);
  const [countResults, setCountResults] = useState<any>(0);
  const [search, setSearch] = useState<any>("");
  const [blockedGroups, setBlockedGroups] = useState<any>([]);
  const [path, setPath] = useState<string>("");
  const [isInvite, setIsInvite] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isMobilePlanSelection, setIsMobilePlanSelection] = useState<boolean>(
    false
  );
  const [hideMobileMenu, setHideMobileMenu] = useState<boolean>(false);
  const [passedSubdomain, setPassedSubdomain] = useState<any>(null);
  const [signin, setSignin] = useState<boolean>(false);
  const [homeLogin, setHomeLogin] = useState<boolean>(false);
  const [authButtonHover, setAuthButtonHover] = useState<boolean>(false);
  const [adminSection, setAdminSection] = useState<boolean>(() => {
    return window.location.pathname.split("/")[1] === "settings"
  });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [communitySearchOpen, setCommunitySearchOpen] = useState<boolean>(false);
  const [groupAppSearchOpen, setGroupAppSearchOpen] = useState<boolean>(false);
  const [postsSearchQuery, setPostsSearchQuery] = useState<string>('');
  const [postsSearchResults, setPostsSearchResults] = useState<any>(null);
  const [isOnboarding, setIsOnboarding] = useState<boolean>(false);

  library.add(faBell);
  library.add(faCog);
  library.add(faChevronDown);

  const searchParama = props.location.search;
  const params = new URLSearchParams(searchParama);
  const history = useHistory()

  useEffect(() => {
    setPassedSubdomain(subdomain);
    const path = props.location.pathname;

    if ((subdomain === undefined || subdomain === null)
      && (group === undefined || group === null)
      && (path === '/' || path === '/login' || path.includes('/search') || isOnboarding)
    ) {
      setHomeLogin(true);
    } else {
      setHomeLogin(false);
    }
  }, [subdomain, group]);

  useEffect(() => {
    if (window.innerWidth < 991) {
      setIsMobile(true);
      setlocalStorageValue("sidebar", false);
      setlocalStorageValue("lecture-sidebar", false);
    } else {
      setlocalStorageValue("lecture-sidebar", true);
    }

    if ((subdomain === undefined || subdomain === null)
      && (group === undefined || group === null)
      && (props.location.pathname === '/' || props.location.pathname === '/login' || window.location.pathname.includes('/search'))
    ) {
      setHomeLogin(true);
    } else {
      setHomeLogin(false);
    }

    if (window.location.pathname === "/invite") {
      setIsInvite(true);
    } else {
      setIsInvite(false);
    }

    if (window.location.pathname === "/signin") {
      setSignin(true);
    } else {
      setSignin(false);
    }

    const invite = params.get("invite");
    if (invite && invite === "true") {
      setIsMobilePlanSelection(true);
    } else {
      setIsMobilePlanSelection(false);
    }

    if (props.location.pathname) {
      setPath(props.location.pathname.split("/")[1]);
    }
    if (
      props.location.pathname.includes("login") ||
      props.location.pathname.includes("forgot-password") ||
      props.location.pathname.includes("signup")
    ) {
      setHideMobileMenu(true);
    }

    if (props.location.pathname.split("/")[1] === 'settings') {
      setAdminSection(true);
    } else {
      setAdminSection(false);
    }

    if (props.location.pathname === "/onboarding") {
      setIsOnboarding(true);
    } else {
      setIsOnboarding(false);
    }
  }, [props.location.pathname]);

  // universal search data 
  const [, setUniversalSearchResults] = useAtom(universalSearchResultsAtom);

  const fetchCommunityContent = () => {
    if (postsSearchQuery && postsSearchQuery.length >= 2) {
      GroupService.getInstance()
        .getCommunityContent(
          props.group.id,
          postsSearchQuery
        )
        .then((response: any) => {
          window.scrollTo(0, 0)
          setUniversalSearchResults(response)
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
    }
  }

  const shouldShowSignupButton = () => {
    if (
      props.group &&
      props.group.sso_enabled &&
      props.group.sso_type === SSOMethod.OAUTH
    ) {
      return (
        props.group.oauth_sso &&
        props.group.oauth_sso.allow_custom_signup
      )
    }

    return true;
  }

  const closedSignup = (): boolean => {
    return props.group && props.group.close_signup
  }

  const activePlans = props.group && props.group.plans.filter((plan: any) => (
    plan.archived_at === null && !plan.hidden
  ));

  // Take a look at this function later for its relevance.
  function redirectToPlanSelection() {
    if (props.history && props.group) {
      if (subdomain) {
        if (activePlans && activePlans.length === 0) history.push('/signup-disabled')
        else {
          history.push(`/plan-subscription`);
        }
      } else {
        history.push(`/group/${props.group.slug}/plan-subscription`);
      }
    }
  }

  const [isDeleteCancelSubModalOpen, setIsDeleteCancelSubModalOpen] = useState<boolean>(false)

  const closeIsDeleteCancelSubModalOpen = () => {
    setIsDeleteCancelSubModalOpen(false)
  }

  function cancelRequest() {
    if (props.user && props.user.id) {
      GroupService.getInstance()
        .leaveGroup(props.user.id, props.group.id)
        .then(() => {
          window.location.reload();
          setIsDeleteCancelSubModalOpen(false)
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
    }
  }

  function clickOnLogo() {
    history.push('/');
    // window.location.assign(`/`);
  }

  function showGroupLogin() {
    if (props.location.pathname.includes('/posts/')) {
      setlocalStorageValue("next_link", window.location.pathname);
    }

    if (subdomain) {
      props.history.push('/signin');
    } else {
      if (props.location.pathname.includes('/group/')) {
        const groupSlug = props.location.pathname.split("/")[2];
        const domain = (appConfig.domain.port) ?
          `${appConfig.domain.baseDomain}:${appConfig.domain.port}`
          : appConfig.domain.baseDomain;

        window.location.assign(`http://${groupSlug}.${domain}/signin`);
      }
    }
  }

  function showGroupSignup() {
    if (
      props.group &&
      props.group.sso_enabled &&
      props.group.sso_type === SSOMethod.OAUTH &&
      props.group.oauth_sso &&
      props.group.oauth_sso.allow_custom_signup &&
      props.group.oauth_sso.custom_signup_url
    ) {
      window.open(props.group.oauth_sso.custom_signup_url, '_self');
      return;
    }
    setChannelSidebarStatus(false);
    if (subdomain) {
      window.location.assign(`${miscUtils.getRedirectBaseUrl(group)}/plan-subscription`);
    } else {
      showPublicGroupSignup();
    }
  }

  function getAdminButtonStyle() {
    const style: { [k: string]: any } = {};
    if (theme && theme.custom && theme.custom.primaryColor !== '#ffffff') {
      style.color = theme.custom.fontColor
      style.border = `1px solid ${theme.custom.fontColor}`;
      if (theme.custom.primaryColor) {
        style.backgroundColor = theme.custom.primaryColor;
      }
    } else {
      style.backgroundColor = '#ffffff';
      style.color = '#666';
    }
    return style;
  }

  const searchInput = useRef(null);

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const {
    ref: postSearchRef,
    isComponentVisible: isPostResultVisible,
    setIsComponentVisible: setIsPostResultVisible,
  } = useComponentVisible(false);

  const [showCommunitySwitcher, setShowCommunitySwitcher] = useAtom(showCommunitySwitcherAtom) as any;
  const [showchannelSidebar, setShowChannelSidebar] = useAtom(showchannelSidebarAtomOnMobile) as any;

  useEffect(() => {
    if (window.innerWidth <= 991 || window.location.pathname.includes('/lectures')) {
      setShowCommunitySwitcher(false);
    }else {
      setShowCommunitySwitcher(true);
    }
  }, [window.location.pathname, window.innerWidth]);


  useEffect(() => {
    if (window.innerWidth <= 991 || window.location.pathname.includes('/lectures')) {
      setShowChannelSidebar(false);
    }else {
      setShowChannelSidebar(false);
    }
  }, [window.location.pathname, window.innerWidth]);
  
  
  const onHamburgerToggle = () => {
    toggleHamburgerMenu();
    setShowCommunitySwitcher(!showCommunitySwitcher);
    setShowChannelSidebar(!showchannelSidebar);
  };

  useEffect(() => {
    if (props.userGroups && props.userGroups.data.length) {
      const blockedGroups: any = [];
      props.userGroups.data.forEach((userGroup: any) => {
        if (userGroup.blocked) {
          blockedGroups.push(userGroup.group.id);
        }
      });
      setBlockedGroups(blockedGroups);
    }
  }, [props.userGroups]);

  useEffect(() => {
    setSearch(props.currentView);
  }, [props.currentView]);

  useEffect(() => {
    if (communitySearchOpen) {
      focusCommunitySearchInput();
    }

    if (!communitySearchOpen && isPostResultVisible) {
      setIsPostResultVisible(false);
    }
  }, [communitySearchOpen]);

  useEffect(() => {
    if (!groupAppSearchOpen && isComponentVisible) {
      setIsComponentVisible(false);
    }
  }, [groupAppSearchOpen]);

  const query = new URLSearchParams(window.location.search);
  const searchText: any = query.get("search");

  // on reload, fetch again
  useEffect(() => {
    if (window.location.pathname === "/filter" && props.group && searchText) {
      GroupService.getInstance()
        .getCommunityContent(
          props.group.id,
          searchText
        )
        .then((response: any) => {
          setUniversalSearchResults(response)
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
    }
  }, [props.group]);

  useEffect(() => {
    if (window.location.pathname !== "/filter") {
      if (postsSearchQuery.length > 0) {
        setPostsSearchQuery("");
      }

      if (postsSearchResults && postsSearchResults.length > 0) {
        setPostsSearchResults(null);
      }
    }

  }, [window.location.pathname]);

  function focusCommunitySearchInput() {
    const communitySearchInputElement: HTMLElement = document.getElementById("gp-community-search-input") as HTMLElement;

    if (communitySearchInputElement) {
      communitySearchInputElement.focus();
    }
  }

  function searchGroups(searchQuery: string) {
    setSearch(searchQuery);
    if (searchQuery.length > 0) {
      GroupService.getInstance()
        .getAllGroups(searchQuery, true)
        .then((response: any) => {
          if (response && response.data) {
            if (blockedGroups.length) {
              response.data = response.data.filter((groupResult: any) => {
                return blockedGroups.indexOf(groupResult.id) < 0;
              });
            }

            setResults(response.data);
            setCountResults(response.data.length);
          }
        }).catch((error: any) => {
          console.error(error)
          new Error(error)
        })
    } else {
      setResults([]);
    }
  }

  function openGroup(targetGroup: any) {
    // reuse util function to open targetGroup selected from dropdown
    setResults([]);
    window.location.assign(miscUtils.getRedirectBaseUrl(targetGroup));
  }

  function handleConfirm(e: any) {
    if (windowSize.width <= 550) {
      if (!groupAppSearchOpen) {
        setGroupAppSearchOpen(true);
        return;
      }
    }
    if (
      (e.key === "Enter" || e.type === "click") &&
      search &&
      search.length > 0
    ) {
      setIsComponentVisible(false);
      goTo(`/search/?q=${search}`);
    }
  }

  function handleSearchInputClick() {
    if (searchInput && searchInput.current) {
      // @ts-ignore
      searchInput.current.setSelectionRange(0, search.length);
    }
    setIsComponentVisible(true);
  }

  function showSignUp() {
    if (
      props.group &&
      props.group.sso_enabled &&
      props.group.sso_type === SSOMethod.OAUTH &&
      props.group.oauth_sso &&
      props.group.oauth_sso.allow_custom_signup &&
      props.group.oauth_sso.custom_signup_url
    ) {
      window.open(props.group.oauth_sso.custom_signup_url, '_self');
      return;
    }
    if (subdomain) {
      if (activePlans && activePlans.length === 0) {
        history.push('/signup-disabled')
      } else {
        window.location.assign(`${miscUtils.getRedirectBaseUrl(group)}/plan-subscription`);
      }
    } else {
      showPublicGroupSignup();
    }
  }

  function onRootUrl() {
    return !passedSubdomain && props.location.pathname === "/";
  }

  function toggleAuthButtonHover() {
    setAuthButtonHover(!authButtonHover);
  }

  function checkForMobile() {
    return (
      isMobile &&
      !isMobilePlanSelection &&
      !hideMobileMenu &&
      !isInvite &&
      !signin &&
      !onRootUrl()
    );
  }

  const isModeratorAndInactive = () => {
    return (
      group &&
      !group.active_subscription &&
      miscUtils.isModerator(group.user_membership)
    )
  }

  const clickOnAdminPanel = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });

    if (group) {
      if (
        isModeratorAndInactive()
      ) {
        setIsOpen(true);
        return;
      }

      if(
        group &&
        group.members_count &&
        group.members_count < 4
      ) {
        history.push('/settings/admin-dashboard', '_self');
        return;
      }

      history.push('/settings/members', '_self');
    }
  }

  const clickOnGettingStarted = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });

    if (group) {
      if (
        isModeratorAndInactive()
      ) {
        setIsOpen(true);
        return;
      }
      // setIsRightSideBarOpen(true);
      history.push('/settings/admin-dashboard')
    }
  }

  const isPurchasePage = (): boolean => {
    const pathParts = window.location.pathname.split("/");
    return pathParts.pop() === "purchase";
  }

  const isPlanSubscriptionPage = (): boolean => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[1] === "plan-subscription";
  }

  const isLibraryLecturePage = (): boolean => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[3] === "lectures" && authed;
  }

  const isNotificationsPage = (): boolean => {
    const pathParts = window.location.pathname.split("/");
    return pathParts.pop() === "notifications";
  }

  const shouldShowLectureMenuIcon = (): boolean => {
    return ((window.location.pathname.includes("courses")) &&
      (window.location.pathname.includes("lectures")) &&
      (windowSize.width <= 960))
  }

  const shouldShowCommunitySearch = () => {
    if (
      !props.group ||
      window.location.pathname.split("/")[1] === "settings" ||
      window.location.pathname === "/invite" ||
      window.location.pathname === "/signin" ||
      window.location.pathname.split("/").pop() === "purchase" ||
      window.location.pathname === "/plan-subscription" ||
      window.location.pathname === "/plan-subscription/checkout" ||
      window.location.pathname === "/about" ||
      isOnboarding
    ) {
      return false;
    }

    return true;
  }

  const [isLoading,] = useAtom(chatsLoadingAtom);


  const { getDirectChats, getCommunityUnread, setMemberCommunityUnreadCount } = React.useContext(DirectChatsContext)

  const chatIconHide = group && group.menu['messages']['show']
  const [groupMenuMessagesShowMenu,] = useAtom(groupMenuMessagesShowAtom);

  const chatsIconsHidden = groupMenuMessagesShowMenu === undefined ? chatIconHide : groupMenuMessagesShowMenu
  const isGroupMember = miscUtils.isGroupMember(group && group)

  const pusherOptions = {
    key: appConfig.pusher.key,
    cluster: appConfig.pusher.cluster,
    broadcaster: appConfig.pusher.broadcaster,
    forceTLS: appConfig.pusher.forceTLS,
    encrypted: appConfig.pusher.encrypted,
    authEndpoint: appConfig.pusher.authEndpoint,
    auth: appConfig.pusher.auth
  };

  function initEcho() {
    return new Echo(pusherOptions);
  }

  const [echo, setEcho] = useState<any>();

  useEffect(() => {
    if (!echo) {
      const echoObj = initEcho();
      setEcho(echoObj);
    }
  }, [])


  useEffect(() => {
    if (echo && group) {
      echo.channel('chat-room')
        .listen(".chatroomsChanged_" + group.id, (response: any) => {
          if (response.chatRoom && group.id === response.chatRoom.group_id) {
            response.communityMemberIds.forEach((memberId: any, index: any) => {
              if (memberId === (group.user_membership && group.user_membership.id) && (response.chatRoom && response.chatRoom.owner && response.chatRoom.owner.id) !== memberId) {
                getDirectChats()
                getCommunityUnread()
              }
            })
          }
        }).listen(".unreadMessage_" + group.id, (response: any) => {
          if (response.communityMemberId === (group.user_membership && group.user_membership.id)) {
            setMemberCommunityUnreadCount(response.communityMemberUnreadCount);
            getDirectChats()
          }
        })
    }
  }, [echo, group])

  const InvitePage = window.location.pathname === "/invite";

  const showJoinCommunityButton = () => {
    return (
      authed && (
        props.group &&
        (
          props.group.user_membership === null ||
          miscUtils.isMembershipPendingApproval(props.group.user_membership)
        ) &&
        // props.group.menu['invite']['show']
        !props.group.close_signup
      ) && (
        !window.location.pathname.includes('invite')) &&
      (!window.location.pathname.includes('plan-subscription'))
    )
  }

  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }

  const hideTopBarOnWorkflowsEdit = () => {
    return (
      (
        window.location.pathname.split("/")[2] === "workflows" &&
        window.location.pathname.split("/").pop() === "edit"
      )
    )
  }

  const hideTopBarOnOnboardingPage = () => {
    return window.location.pathname === "/onboarding"

  }
  const commWhiteThemeColor = group && group.custom_branding && group.custom_branding.primaryColor
  const previewPage = (window.location.pathname === '/plan-subscription-preview') || (window.location.pathname === '/about-preview')
  const switcherElement: any = document.getElementById('communities-sidebar');
  
  const commFontColorColor = group && group.custom_branding && group.custom_branding.fontColor

  return (
    <header className={`g-header ${isModalActive ? "js-modal-active" : ""} ${hideTopBarOnWorkflowsEdit() || hideTopBarOnOnboardingPage() ? 'hide-topbar' : ''} ${previewPage ? 'no-borderB' : ""}`}
      style={{
        top: showUpgradeBanner.isOpen
          ? `calc(${miscUtils.getTopOffsetForMobile('UpgradePlanBanner')}px + env(safe-area-inset-top))`
          :
          showBanner
            ?
            `calc(${miscUtils.getTopOffsetForMobile('SmartAppBanner')}px + env(safe-area-inset-top))`
            : 0,

        ...(miscUtils.customGroupThemeSet(group && group)
          ? { backgroundColor:commWhiteThemeColor, borderBottom: `1px solid ${commWhiteThemeColor}` }
          : {}),
        padding: (adminSection && window.innerWidth > 767) ? '0 24px' : 
                  (window.location.pathname === '/about' && window.innerWidth > 767) ? '0 20px' : 
                    (switcherElement && window.innerWidth > 767 && !window.location.pathname.includes('/lectures')) ? '0 5.8rem' : '',
        paddingRight: (switcherElement && window.innerWidth > 767 && !window.location.pathname.includes('/lectures')) ? '24px' : '',
      }}
      id='GroupAppHeader'
    >
      <div className={`${!authed ? "no-auth" : ""} header-wrap flex flex-align-center ${isOnboarding ? "onboarding" : ""} ${InvitePage ? 'no-padding' : ''}`}>
        <div className="header-action-left flex-align-center flex">
          {
            isLibraryLecturePage() &&
            (
              <div
                className="library-lecture-action"
              >
                <button
                  onClick={onHamburgerToggle}
                >
                  <span
                    style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                  />
                  <span
                    style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                  />
                  <span
                    style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                  />
                </button>
              </div>
            )
          }

          {/* Show this hamburger on notifications page */}
          {isNotificationsPage() && window.innerWidth <= 550 && (
            <div
              className="notifications-page-hamburger"
            >
              <button
                onClick={onHamburgerToggle}
              >
                <span
                  style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                />
                <span
                  style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                />
                <span
                  style={(miscUtils.customThemeSet(theme) && !adminSection) ? { backgroundColor: theme.custom.fontColor } : {}}
                />
              </button>
            </div>
          )}

          {((authed && !isMobilePlanSelection && group) || checkForMobile()) && (!isPurchasePage()) && (!isPlanSubscriptionPage()) && (!isLibraryLecturePage()) && (!isNotificationsPage()) && !isOnboarding && (
            <div className="header-action flex flex-justify-center flex-align-center">
              <button
                className={
                  global.toggleSidebar
                    ? "flex-align-center flex-direction-column flex is-sidebar-open"
                    : "flex-align-center flex-direction-column flex"
                }
                onClick={onHamburgerToggle}
                id={!authed ? 'hamburger-toggle-button' : ''}
              >
                <span
                 style={miscUtils.customGroupThemeSet(group && group) ? { backgroundColor: '#fff' } : {backgroundColor: '#666' }}
                />
                <span
                 style={miscUtils.customGroupThemeSet(group && group) ? { backgroundColor: '#fff' } : {backgroundColor: '#666' }}
                />
                <span
                 style={miscUtils.customGroupThemeSet(group && group) ? { backgroundColor: '#fff' } : {backgroundColor: '#666' }}
                />
              </button>
            </div>
          )}
          {homeLogin && subdomain === null && (
            <div onClick={() => clickOnLogo()} className={`header-logo ${window.location.pathname === "/onboarding" ? "disabled" : ""}`}>
              <GroupApp />
            </div>
          )}
          <div className='community-search-container'>

          {
            subdomain 
            ?
          <div className={`dropdown-menu header-communities`}>
            <Link
              to="/"
              onClick={() => clickOnLogo()}
              className={`groupapp-logo ${window.location.pathname === "/onboarding" ? "disabled" : ""}`}
            >
              {group && group.profile_image && isValidImage && (
                <img src={group.profile_image} alt={"group-profile"} onError={onImageError} />
              )}

              {group && (!group.profile_image || !isValidImage) && (
                <div className="profile-image" data-color={miscUtils.getColorInitial(group.name)}>
                  <div className="group-name">{miscUtils.getNameInitials(group.name)}</div>
                </div>
              )}
            </Link>
              {
                window.innerWidth > 1024 &&
             <Link
              to="/"
              onClick={() => clickOnLogo()}
                className="header-communities-community-name">
              <p 
              style={commFontColorColor ? {color: commFontColorColor} : {}}
              title={group && group.name}
              className="header-communities-community-name-text">{group && group.name}</p>
            </Link>
              }
          </div>
          :
          <></>
          }

          {shouldShowCommunitySearch() && (

              <div
                className={`gp-community-search-container ${(!chatsIconsHidden || (!isGroupMember && authed)) ? 'chat-icon-hidden' : ''} ${!authed ? 'unauthed' : ''}  ${communitySearchOpen ? 'mobile-open' : ''} ${(window.location.pathname.includes("courses") && window.location.pathname.includes("lectures") && authed ? 'course-lecture-page' : '')
                  } ${showJoinCommunityButton() ? 'join-community' : ''} ${window.location.pathname.includes('library') &&
                    window.location.pathname.includes("lectures") ?
                    'library-content-lecture-page' :
                    ''
                  } ${!authed && !shouldShowSignupButton() ?
                    'signup-hidden' :
                    ''
                  } ${showJoinCommunityButton() &&
                    window.location.pathname.includes("courses") &&
                    window.location.pathname.includes("lectures") &&
                    authed ?
                    'course-lecture-page-join-community' :
                    ''
                  }
                    ${(!authed && closedSignup()) ? 'closed_signup' : ''}
                  `}
                ref={postSearchRef}
              >
                <span
                  className={`gp-community-search-close ${communitySearchOpen ? 'mobile-open' : ''}`}
                  onClick={() => {
                    if (communitySearchOpen) {
                      setCommunitySearchOpen(false);
                    }
                  }}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                  />
                </span>
                <input
                  type="text"
                  placeholder="Search community"
                  className={`gp-community-search-input ${communitySearchOpen ? 'mobile-open' : ''} ${(commWhiteThemeColor === null) || (commWhiteThemeColor === '#ffffff') || (commWhiteThemeColor === '#fafafa') ? 'search-border' : ""}`}
                  id="gp-community-search-input"
                  value={postsSearchQuery}
                  onChange={(e: any) => setPostsSearchQuery(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      if (props.group && postsSearchQuery.length >= 2) {
                        setUniversalSearchResults(undefined)
                        fetchCommunityContent()
                        history.push(`/filter?search=${postsSearchQuery}`)
                      }
                    }
                  }}
                  onClick={() => {
                    setIsPostResultVisible(true);
                  }}
                />
                <span
                  className={`gp-community-search-icon ${communitySearchOpen ? 'mobile-open' : ''} ${authed ? '' : 'logged-out'
                    }`}
                  onClick={() => {
                    if (!communitySearchOpen) {
                      setCommunitySearchOpen(true);
                    }
                    if (props.group && postsSearchQuery.length >= 2) {
                      setUniversalSearchResults(undefined)
                      fetchCommunityContent()

                      history.push(`/filter?search=${postsSearchQuery}`)
                    }
                  }}
                >
                  <SearchIcon
                    fill={windowSize.width > 550 ? undefined : theme && theme.custom ? theme.custom.fontColor : undefined}
                  />
                </span>
              </div>
          )}

          {authed && homeLogin && subdomain === null && !isOnboarding && (
            <div
              className={`header-search ${groupAppSearchOpen ? 'mobile-open' : ''}`}
              ref={ref}>
              <span
                className={`close-groupapp-search ${groupAppSearchOpen ? 'mobile-open' : ''}`}
                onClick={() => {
                  if (groupAppSearchOpen) {
                    setGroupAppSearchOpen(false);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                />
              </span>
              <input
                ref={searchInput}
                onKeyDown={handleConfirm}
                value={search}
                onChange={e => searchGroups(e.target.value)}
                placeholder="Search for a community"
                onClick={handleSearchInputClick}
              />
              <span
                className="icon-groupapp-search"
                onClick={handleConfirm}
              >
                <SearchIcon />
              </span>

              {results.length > 0 && isComponentVisible && (
                <div className="search-results">
                  <div>
                    {results.slice(0, 5).map((result: any) => {
                      return (
                        <div
                          key={result.id}
                          onClick={() => {
                            openGroup(result);
                          }}
                          className="search-result flex flex-justify-space-between"
                        >
                          <div className="search-result-group-info flex flex-align-center">
                            {(result.profile_image && isValidImage) ? (
                              <img
                                alt={result.name}
                                className="profile-image"
                                src={result.profile_image}
                                onError={onImageError}
                              />
                            ) : (
                              <div className="profile-image">
                                {miscUtils.getNameInitials(result.name)}
                              </div>
                            )}
                            <div className="group-name">{result.name}</div>
                          </div>

                          <div className="group-status">
                            {result.status.toLowerCase()} group
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {countResults > 5 && (
                    <div className="search-more-results flex flex-align-center flex-justify-center">
                      <Link
                        onClick={() => setIsComponentVisible(false)}
                        to={{
                          pathname: "/search",
                          search: `?q=${search}`
                        }}
                      >
                        View All Results
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        <div className={`header-action-right flex-align-center flex ${window.location.pathname.includes('/lectures') ? 'header-action-right-lecture' : ''} ${!authed ? 'header-action-right-unauthed' : ''} `}>

          {
            (
              (authed && group && group.user_membership && group.user_membership.owner) ||
              (authed && group && group.user_membership && miscUtils.isAdmin(group.user_membership)) ||
              (authed && group && group.user_membership && miscUtils.isModerator(group.user_membership))
            ) &&
            (
              // !window.location.pathname.includes("/settings")
              window.location.pathname.split("/")[1] !== "settings"
            ) &&
            !isOnboarding &&
            (authed && group && group.user_membership && !miscUtils.isMembershipPendingApproval(group.user_membership)) &&
            (
              <Link
                to={
                  !group || 
                  (group && isModeratorAndInactive()) ? '#' : 
                  group &&
                  group.members_count &&
                  group.members_count < 4 ?
                  `/settings/admin-dashboard` :
                  `/settings/members`
                }
                onClick={clickOnAdminPanel}
                className={`header-create-group ${shouldShowLectureMenuIcon() ? 'header-cteate-group-lecture' : ''} ${theme && theme.custom && theme.custom.primaryColor === '#ffffff' && 'hover-color'}`}
                style={getAdminButtonStyle()}
              >
                Admin Panel
              </Link>
            )}

          {
            (
              group &&
              group.user_membership &&
              authed &&
              (
                miscUtils.isAdmin(group.user_membership) || miscUtils.isModerator(group.user_membership)
              )
            ) &&
            window.location.pathname !== "/onboarding" &&
            window.location.pathname.split("/")[1] === "settings" &&
            !miscUtils.isMembershipPendingApproval(group.user_membership) &&
            (
              <span
                onClick={clickOnGettingStarted}
                className="getting-started-btn"
                style={getAdminButtonStyle()}
              >
                Getting Started
              </span>
            )
          }

          {authed && !isOnboarding &&
            <>
              <TopBarNotificationComponent
                subdomain={subdomain}
                group={group}
                theme={!adminSection ? theme : null}
                lectureView={shouldShowLectureMenuIcon()}
                refreshNotificationsCountRef={props.refreshNotificationsCountRef}
              />

              <TopBarMenuComponent
                group={group}
                theme={!adminSection ? theme : null}
                lectureView={shouldShowLectureMenuIcon()}
                subdomain={subdomain}
              />
              {
                group &&
                chatsIconsHidden &&
                isGroupMember &&
                !miscUtils.isMembershipPendingApproval(group.user_membership) &&
                (
                  <TobBarMessages
                    group={group && group}
                    theme={!adminSection ? theme : null}
                    getCommunityUnread={getCommunityUnread}
                    isLoading={isLoading}
                    lectureView={shouldShowLectureMenuIcon()}
                  />
                )}
            </>
          }

          {authed &&
            shouldShowLectureMenuIcon() && (
              <span
                className={`topbar-lecture-menu-toggle-button`}
                onClick={() => {
                  forceUpdate(null);
                  setTimeout(() => {
                    props.toggleLectureMenuRef.current();
                  }, 100);
                }}
              >
                <LectureMenuIcon
                  strokeColor={miscUtils.customThemeSet(theme) && theme.custom.fontColor}
                />
              </span>
            )}
          {!authed && !search && !params.get("invite") && path !== "posts" && (
            <div className="header-menu" />
          )}
          {!authed && (search && search.length > 0 || path === 'library' || path === 'courses' || path === 'events' || path === "invite-preview" || path === "about-community" || path === "feed" || isInvite) &&
            window.location.pathname.split("/").pop() !== 'purchase' && (
              <div className="header-menu public-group-menu flex">
                {!signin && path !== "posts" && (
                  <>
                    {!window.location.pathname.includes("outline") && (
                      <button
                        style={miscUtils.getBlockInverseButtonStyle(!adminSection && theme && !whiteCommunityTheme ? theme : null)}
                        onClick={() => showGroupLogin()}
                        className="btn btn-no-style btn-header-login"
                        type="button"
                      >
                        Log in
                      </button>
                    )}
                  </>
                )}
                {!isInvite && !signin && path !== "invite-preview" && shouldShowSignupButton() && path !== "posts" && (props.group && !props.group.close_signup) && (
                  <>
                    {!window.location.pathname.includes("outline") && (
                      <button
                        style={miscUtils.getBlockInverseButtonStyle(!adminSection && theme && !whiteCommunityTheme ? theme : null)}
                        onMouseEnter={toggleAuthButtonHover}
                        onMouseLeave={toggleAuthButtonHover}
                        onClick={() => showSignUp()}
                        className="btn btn-no-style btn-header-signup"
                        type="button"
                      >
                        Sign up
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          {showJoinCommunityButton() &&
            (
              <button
                style={miscUtils.getBlockInverseButtonStyle(!adminSection ? theme : null)}
                onClick={() => {
                  if (miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership)) {
                    setIsDeleteCancelSubModalOpen(true)
                  } else {
                    redirectToPlanSelection();
                  }
                }}
                className={`${(theme && theme.custom) ? "" : 'btn-border'} "btn btn-no-style groupapp-join-community-button ${window.location.pathname.includes("courses") &&
                  window.location.pathname.includes("lectures") &&
                  authed ?
                  'course-lecture-page' :
                  ''
                  }`}
                type="button"
              >
                {miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership) ? "Cancel Request" : "Join Community"}
              </button>
            )}
          {path === "posts" && !authed && (
            <div className="header-menu public-group-menu flex">
              {!isInvite && (
                <button
                  style={miscUtils.getBlockInverseButtonStyle(!adminSection ? theme : null)}
                  onClick={() => showGroupLogin()}
                  className="btn btn-no-style btn-header-login"
                  type="button"
                >
                  Log in
                </button>
              )}
              {!isInvite && shouldShowSignupButton() && (props.group && !props.group.close_signup) && (
                <button
                  style={miscUtils.getBlockInverseButtonStyle(!adminSection ? theme : null)}
                  onClick={() => showGroupSignup()}
                  className="btn btn-no-style btn-header-signup"
                  type="button"
                >
                  Sign up
                </button>
              )}
            </div>
          )}
        </div>
          </div>

        </div>
      </div>
      <>
        <AppModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title="Community Subscription Expired"
          message="Please contact an admin to renew the subscription"
          buttonText="OK"
        />

        <ConfirmModal
          isModalOpen={isDeleteCancelSubModalOpen}
          closeModal={closeIsDeleteCancelSubModalOpen}
          actionCallback={cancelRequest}
          modalSubTitle="Are you sure you would like to cancel your pending membership request?"
          modalTitle="Confirm action"
          actionBtn="Yes"
          cancelBtn='No'
        />
      </>
    </header>
  );
};

// - Map dispatch to props
const mapDispatchToProps = (
  dispatch: any,
  ownProps: ITopBarComponentsProps
) => {
  return {
    setPostsQuery: (query: string) =>
      dispatch(globalActions.setPostsQuery(query)),
    toggleHamburgerMenu: () => dispatch(globalActions.toggleHamburgerMenu()),
    showPublicGroupLogin: () => dispatch(globalActions.showPublicGroupLogin()),
    setChannelSidebarStatus: (status: boolean) =>
      dispatch(globalActions.setSidebarForChannel(status)),
    showPublicGroupSignup: () =>
      dispatch(globalActions.showPublicGroupSignup()),
    goTo: (url: string) => dispatch(push(url)),
    logout: () => {
      dispatch(authorizeActions.dbLogout());
    },
    createGroup: () => {
      dispatch(push("/creategroup"));
    }
  };
};
const mapStateToProps = (state: any, ownProps: ITopBarComponentsProps) => {
  const global = Map(state.get("global", {})).toJS() as any;
  const groups: any = Map(state.get("group", {})).toJS();
  return {
    global,
    theme: global.theme,
    selectedGroup: global.selectedGroup,
    currentView: global.currentView,
    userGroups: groups.userGroups,
    isModalActive: global.isModalActive
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TopBarComponent as any) as any
) as any;
